module.exports = __webpack_public_path__ + "img/NODETESTCOIN-icon.b616c15.png";